import ExpertProfileReviewsEditModalComponent from './expert-profile-reviews-edit-modal.component'

const ExpertProfileReviewsEditModalModule = angular.module('cdbl.expert-profile.expert-profile-reviews-edit-modal', [

])
  .component('cdblExpertProfileReviewsEditModal', ExpertProfileReviewsEditModalComponent)
  .name

export default ExpertProfileReviewsEditModalModule
